import { render, staticRenderFns } from "./DeliveryInput.vue?vue&type=template&id=02893f55&scoped=true&"
import script from "./DeliveryInput.vue?vue&type=script&lang=ts&"
export * from "./DeliveryInput.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryInput.vue?vue&type=style&index=0&id=02893f55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02893f55",
  null
  
)

export default component.exports